import {jsx} from 'panel';

import {StringOperator} from 'common/widgets/property-filter-menu/models/types';
import {PropertyValuesScreenEl} from 'common/widgets/property-filter-menu/property-values-screen';
import {SelectEl} from 'common/components/select';
import {EntryPart} from 'common/widgets/query-entry-section/types';
import {CommitPropertyFilterEvent} from 'common/widgets/property-filter-menu/property-values-screen/types';

import {FilterValueProps} from '../types';

const NO_VALUE_OPERATORS = new Set<StringOperator>([StringOperator.Set, StringOperator.NotSet]);

export function FilterStringValue({
  index,
  activeEntry,
  entryPart,
  filter,
  handleFilterValueChange,
  onSelectMenuChange,
  eventNames,
  projectId,
  workspaceId,
  readOnlyMode,
}: FilterValueProps) {
  const isOpen = activeEntry === index && entryPart === EntryPart.FilterValue;

  // set and not set do not require a filter value input
  if (NO_VALUE_OPERATORS.has(filter.filterOperator as StringOperator)) {
    return null;
  }

  const label = filter
    .getLabelParts()
    .slice(2)
    .map((item) => item.label)
    .join(` `);

  return (
    <SelectEl
      class={{
        'is-placeholder': !filter.isValid(),
      }}
      attrs={{
        elref: `filterValueSelect`,
        open: isOpen,
        theme: `select`,
        'selected-option': filter.isValid() ? label : `Select value...`,
        readonly: readOnlyMode,
      }}
      on={{
        menuChange: (ev) => onSelectMenuChange(ev, index, EntryPart.FilterValue),
      }}
    >
      {isOpen && (
        <PropertyValuesScreenEl
          attrs={{
            elref: `filterValue`,
            slot: `body`,
            'display-value-only': true,
            'event-names': eventNames,
            'property-filter': filter.getAttributes(),
            'project-id': projectId,
            'workspace-id': workspaceId,
          }}
          on={{
            commitPropertyFilter: (ev: CommitPropertyFilterEvent) =>
              handleFilterValueChange(ev.detail.propertyFilter.filterValue),
          }}
        />
      )}
    </SelectEl>
  );
}
